<template>
  <span class="pagination__sizes">
    <el-select
      :value="$parent.internalPageSize"
      :popperClass="$parent.popperClass || ''"
      size="mini"
      @input="handleChange"
      :disabled="$parent.disabled"
    >
      <el-option
        v-for="item in pageSizes"
        :key="item"
        :value="item"
        :label="item + i18n.t('el.pagination.pagesize')"
      >
      </el-option>
    </el-select>
  </span>
</template>

<script>
import i18n from '@/lang'
const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true
  if (!(a instanceof Array)) return false
  if (!(b instanceof Array)) return false
  if (a.length !== b.length) return false
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false
  }
  return true
}

export default {
  props: {
    pageSizes: Array
  },
  data () {
    return {
      i18n
    }
  },
  watch: {
    pageSizes: {
      immediate: true,
      handler (newVal, oldVal) {
        if (valueEquals(newVal, oldVal)) return
        if (Array.isArray(newVal)) {
          this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1
            ? this.$parent.pageSize
            : this.pageSizes[0]
        }
      }
    }
  },

  methods: {
    handleChange (val) {
      if (val !== this.$parent.internalPageSize) {
        this.$parent.internalPageSize = val = parseInt(val, 10)
        this.$parent.userChangePageSize = true
        this.$parent.$emit('update:pageSize', val)
        this.$parent.$emit('size-change', val)
      }
    }
  }
}
</script>

<style>
</style>
